var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10877 15.6923L10.8713 20.7641C11.0032 20.863 11.1549 20.9178 11.3105 20.9227C11.466 20.9276 11.6198 20.8825 11.756 20.7919C11.8921 20.7014 12.0055 20.5688 12.0845 20.4079C12.1635 20.247 12.2051 20.0637 12.2051 19.8769V1.04616C12.2051 0.859412 12.1635 0.676072 12.0845 0.515171C12.0055 0.354269 11.8921 0.221671 11.756 0.131144C11.6198 0.0406161 11.466 -0.00454109 11.3105 0.000360514C11.1549 0.00526212 11.0032 0.0600437 10.8713 0.159018L4.10877 5.23077H0.871795C0.64058 5.23077 0.418836 5.34099 0.255343 5.53718C0.0918497 5.73337 0 5.99947 0 6.27692V14.6462C0 14.9236 0.0918497 15.1897 0.255343 15.3859C0.418836 15.5821 0.64058 15.6923 0.871795 15.6923H4.10877Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.84616C17 6.40172 15.8291 5.23077 14.3846 5.23077V15.6923C15.8291 15.6923 17 14.5214 17 13.0769V7.84616Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewVolume);
export default __webpack_public_path__ + "static/media/newVolume.014cac930094623316827ce13db321ae.svg";
export { ForwardRef as ReactComponent };